import CommissionInput from "@/components/shared/CommissionInput/CommissionInput.tsx";
import { Input } from "@/components/shared/Input/Input";
import { Button } from "@/components/ui/button";
import { SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { CreateCoProducerDTO } from "@/services/coproducer.service.ts";
import useModalStore from "@/store/useModalStore";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useCoproducers } from "../hooks/useCoProducer.ts";

export default function InviteCoProducerSheet() {
  const { t } = useTranslation("coproducer");
  const { closeModal } = useModalStore();

  const { createCoproducer, isLoading, isPending } = useCoproducers();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<CreateCoProducerDTO>({
    defaultValues: {
      email: "",
      percentage: "1.00",
      role: "coproducer",
      participate_producer_sales: true,
      participate_affiliates_sales: false,
    },
  });

  const onSubmit = async (data: CreateCoProducerDTO) => {
    const formatedData = {
      ...data,
      percentage: parseFloat(data.percentage).toFixed(2).toString(),
    };
    createCoproducer(formatedData);
  };



  return (
    <section className="sm:overflow-y-hidden flex flex-col justify-between h-full">
      <SheetHeader className="p-6">
        <SheetTitle className="flex gap-2"> {t("create_title")}</SheetTitle>
      </SheetHeader>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col justify-between h-full"
      >
        <section className="flex flex-col gap-4 px-6">
          <Input
            label="E-mail"
            placeholder={t("email_placeholder")}
            {...register("email", {
              required: t("email_required"),
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: t("email_invalid"),
              },
            })}
            data-cy="input-coproducer-email"
            helperText={errors.email?.message}
          />

          <div className="w-[50%]">
            <CommissionInput
              label={t("commission")}
              helperText={errors.percentage?.message}
              type="number"
              placeholder="1.00"
              maxLength={5}
              dataCy="input-coproducer-commission"
              {...register("percentage", {
                required: t("commission_required"),
                pattern: {
                  value: /^\d+\.?\d{0,2}$/,
                  message: t("commission_invalid_format"),
                },
                validate: {
                  validRange: (value) => {
                    const numValue = parseFloat(value);
                    return (
                      (numValue >= 0.01 && numValue <= 99) ||
                      t("commission_range_error")
                    );
                  },
                },
              })}
              onChangeCommission={(value) => setValue("percentage", value)}
            />
          </div>
        </section>

        <section className="flex border-t items-center justify-end gap-4 px-6 py-4 w-full max-sm:pb-12">
          <Button
            type="button"
            variant="ghost"
            onClick={() => closeModal("invite-co-producer")}
          >
            {t("cancel")}
          </Button>
          <Button type="submit" disabled={isPending} data-cy="btn-submit-create-coproducer">
            {isPending ? t("submitting") : t("submit")}
          </Button>
        </section>
      </form>
    </section>
  );
}
